import { useTranslation } from 'react-i18next'
import SelectedCareerCard from './SelectedCareerCard'

export default function SelectedCareersList({
  selectedCareers,
  onCareerRemove
}) {
  const { t } = useTranslation()
  return (
    <div className='mt-4'>
      <h4 className='mb-2 text-sm font-medium text-gray-900'>
        {t('discover.add_career_modal.selected_careers_count', {
          count: selectedCareers.length
        })}
      </h4>
      <div className='flex max-h-64 w-full flex-row flex-wrap gap-2 overflow-y-scroll'>
        {selectedCareers.map((career) => (
          <SelectedCareerCard
            key={career.id}
            career={career}
            onRemove={onCareerRemove}
          />
        ))}
      </div>
    </div>
  )
}
